import React from 'react';
import LinkButton from '../global/LinkButton';
import {
  creativeTitle,
  infoContainer,
  serviceContainer,
} from './ProjectInfo.module.scss';

const ProjectInfo = ({
  client,
  link,
  services,
  title_creative,
  title_descriptive,
}) => {
  return (
    <div className={`pagePadding pageGrid`}>
      <div className={`${infoContainer} gridCenterContent`}>
        {client && (
          <div>
            <h2 className={`h5 mb16`}>
              <a href={`${client.link}`} className={`inlineBlock mb8`}>
                {client.name}
              </a>
              <span className={`h4 block`}>
                {title_creative && (
                  <span className={`${creativeTitle}`}>{title_creative} </span>
                )}
                {title_descriptive}
              </span>
            </h2>
            {link && <LinkButton text={'Visit Project'} url={link} />}
          </div>
        )}
        {services && (
          <div>
            <h3 className={`h5 pb12`}>Categories</h3>
            <ul className={`${serviceContainer} `}>
              {services.map(({ tile_title, tile_id }, index) => (
                <li key={index}>
                  <LinkButton
                    small
                    text={tile_title}
                    url={`/services/?service=${tile_id}#services`}
                    color="Midnight"
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
export default ProjectInfo;
